// loader.component.ts
import { Component } from '@angular/core';
import { LoadingService } from './loading.service';

@Component({
  selector: 'app-loader',
  templateUrl: './appLoader.component.html',
  styleUrls: ['./appLoader.component.scss']
})
export class appLoaderComponent {
  constructor(public loadingService: LoadingService) { }
}
